import Menu from './graphql/Menu'
import Account from './graphql/Account'
import Order from './graphql/Order'
import Section from './graphql/Section'
import Address from './graphql/Address'
import Division from './graphql/Division'
import Department from './graphql/Department'
import DepartmentReport from './graphql/DepartmentReport'
import Channel from './graphql/Channel'
import System from './graphql/System'

export default {
  ...Menu,
  ...Account,
  ...Order,
  ...Section,
  ...Address,
  ...Division,
  ...Department,
  ...DepartmentReport,
  ...Channel,
  ...System
}
